.full-width {
  width: 100%;
}

.loading {
  margin: var(--rc-theme-spacing-xxs);
  text-align: center;
}

.popup :global(.ant-select-item-option-disabled) {
  color: var(--rc-theme-color-text-disabled);
}
